import { render, staticRenderFns } from "./modal-clinic.vue?vue&type=template&id=9424b02c&"
import script from "./modal-clinic.vue?vue&type=script&lang=js&"
export * from "./modal-clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports